import { AdminContainer } from '@/components/containers/containers.component';
import { EditUserForm } from '@/components/forms/edit-user.form.component';
import { cn } from '@/lib/utils';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';

export default function AddUser() {
  return (
    <IfPermitted permissions={[UserPermissions.ADD_USER]}>
      <AdminContainer className={cn('flex flex-col')} title="Add User">
        <EditUserForm />
      </AdminContainer>
    </IfPermitted>
  );
}
